export default __webpack_public_path__ + "static/media/tree1.51168c2f.png";